import { render } from "./myHeaderW.vue?vue&type=template&id=9fa8a42e&scoped=true"
import script from "./myHeaderW.vue?vue&type=script&lang=js"
export * from "./myHeaderW.vue?vue&type=script&lang=js"

import "./myHeaderW.vue?vue&type=style&index=0&id=9fa8a42e&lang=scss&scoped=true"

import exportComponent from "/chaopin/jpom/data/build/66617637594a40d3882f98d9518ea655/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa8a42e"]])

export default __exports__